export default "__VITE_ASSET__jQKwih_1__"